// extracted by mini-css-extract-plugin
module.exports = {"paragraphTitle":"styles_paragraphTitle__N_g0U"};